var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.subscriptions.length == 0)?_c('no-ssl'):_vm._e(),_vm._l((_vm.subscriptions),function(subscription,index){return _c('ssl-item',{key:index,attrs:{"domain":_vm.domain,"subscription":subscription}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }